import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Inline version badge rendered in the admin panel header.
 * Shows environment, build version, and commit SHA so the operator can
 * instantly verify which build is running when they open the admin panel.
 */
export const VersionBadge = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/version`).then(r => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return null;

  const env = (info.environment || 'local').toLowerCase();
  const envStyle = {
    production: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
    preview: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    local: 'bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  }[env] || 'bg-slate-200 text-slate-700';

  const builtAgo = info.built_at ? timeAgo(info.built_at) : null;

  return (
    <div
      data-testid="version-badge"
      className="inline-flex items-center gap-2 text-[11px] font-mono"
      title={`SHA: ${info.sha}\nBuilt: ${info.built_at}\nBooted: ${info.uptime_boot_at}\nCommit: ${info.commit_message || ''}`}
    >
      <span className={`px-2 py-0.5 rounded-full font-sans font-semibold uppercase tracking-wide ${envStyle}`}>
        {env}
      </span>
      <span className="text-muted-foreground">
        {info.version}
        {builtAgo && <span className="ml-1.5 opacity-70">· built {builtAgo}</span>}
      </span>
    </div>
  );
};

function timeAgo(iso) {
  try {
    const delta = (Date.now() - new Date(iso).getTime()) / 1000;
    if (delta < 60) return 'just now';
    if (delta < 3600) return `${Math.floor(delta / 60)}m ago`;
    if (delta < 86400) return `${Math.floor(delta / 3600)}h ago`;
    if (delta < 604800) return `${Math.floor(delta / 86400)}d ago`;
    return new Date(iso).toLocaleDateString();
  } catch { return ''; }
}
